import { render, staticRenderFns } from "./styleguide.vue?vue&type=template&id=f125ae9e&"
import script from "./styleguide.vue?vue&type=script&lang=js&"
export * from "./styleguide.vue?vue&type=script&lang=js&"
import style0 from "./styleguide.vue?vue&type=style&index=0&id=f125ae9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports